export default __webpack_public_path__ + "images/7Q.27b6cba.png";